
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { AccountingPlanModel } from './Entities.Accounting.AccountingPlan';
import { PriceAdjustmentModel } from './Entities.Accounting.PriceAdjustment';
import { BcDocumentLineType } from 'enums/BcDocumentLineType';
import { Model, ModelProperty } from 'models/Model';


export class AccountingPlanSetupModel extends Model<AccountingPlanSetupModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'productDimensionCode', type: 'string' },
		{ name: 'startup', type: 'number' },
		{ name: 'exportTypeNo', type: 'string' },
		{ name: 'startDate', type: 'Date' },
		{ name: 'endDate', type: 'Date' },
		{ name: 'priceAdjustmentId', type: 'string' },
		{ name: 'replacesAccountingPlanSetupId', type: 'string' },
		{ name: 'accountingPlans', type: 'AccountingPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanModel }, properties: () => { return AccountingPlanModel.classProperties } },
		{ name: 'inverseReplacesAccountingPlanSetup', type: 'AccountingPlanSetupModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'priceAdjustment', type: 'PriceAdjustmentModel', isHidden: true, isObject: true, new: () => { return new PriceAdjustmentModel }, properties: () => { return PriceAdjustmentModel.classProperties } },
		{ name: 'replacesAccountingPlanSetup', type: 'AccountingPlanSetupModel', isHidden: true, isObject: true, new: () => { return new AccountingPlanSetupModel }, properties: () => { return AccountingPlanSetupModel.classProperties } },
		{ name: 'exportType', type: 'BcDocumentLineType' }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public productDimensionCode: string;
	public startup: number;
	public exportTypeNo: string;
	public startDate?: Date;
	public endDate?: Date;
	public priceAdjustmentId?: string;
	public replacesAccountingPlanSetupId?: string;
	public accountingPlans: AccountingPlanModel[];
	public inverseReplacesAccountingPlanSetup: AccountingPlanSetupModel[];
	public priceAdjustment?: PriceAdjustmentModel;
	public replacesAccountingPlanSetup?: AccountingPlanSetupModel;
	public exportType: BcDocumentLineType;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.productDimensionCode = '';
		this.startup = 0;
		this.exportTypeNo = '';
		this.startDate = undefined;
		this.endDate = undefined;
		this.priceAdjustmentId = undefined;
		this.replacesAccountingPlanSetupId = undefined;
		this.accountingPlans = [];
		this.inverseReplacesAccountingPlanSetup = [];
		this.priceAdjustment = undefined;
		this.replacesAccountingPlanSetup = undefined;
		this.exportType = 0;
		
	}
	getProperties(){
		return AccountingPlanSetupModel.classProperties;
	}
}

